module.exports = __webpack_public_path__ + "static/media/WealthUpCapitalT.93d78d18.png";